import Vue from "vue";
import axios from "axios";
import { VueAxios } from "./axios";
import { ACCESS_TOKEN } from "../store/mutation-types";
import { Log } from "./debug";
import store from "@/store";

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_API_URL || "/api", // api base_url
    timeout: 5000 // 请求超时时间
});

service.interceptors.request.use(config => {
    config.data = JSON.stringify(config.data);
    config.headers["Content-Type"] = "application/json";

    const token = Vue.ls.get(ACCESS_TOKEN);
    if (token) {
        config.headers.Authorization = token;
    }

    return config;
});

const err = error => {
    Log.debug(error);

    if (error.response) {
        let msg = "error.";

        if (error.response.data.ErrorMsg) msg = error.response.data.ErrorMsg;

        store.commit("muNotice", {
            type: "error",
            msg: msg,
            timeout: 6000
        });
    }

    return Promise.reject((error || {}).data);
};

service.interceptors.response.use(response => {
    Log.debug(response);
    if (response.data["ErrorCode"]) {
        if (response.data["ErrorCode"] === 401) {
            //if no auth, redirect to login.html
            window.location = "/login";
            return;
        }

        return Promise.reject(response.data);
    } else {
        return Promise.resolve(response.data);
    }
}, err);

const installer = {
    vm: {},
    install(vue) {
        vue.use(VueAxios, service);
    }
};

export { installer as VueAxios, service as axios };
